// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".body[data-v-1c63d24e]{width:100%;margin:auto;position:relative;z-index:10}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
